import axios from "axios";
const BASE = process.env.REACT_APP_BACKEND_URL;
const API = `${BASE}/api`;

const TOKEN_KEY = "wk_admin_token";
export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

const authHeaders = () => {
  const t = getToken();
  return t ? { Authorization: `Bearer ${t}` } : {};
};

export const adminLogin = (email, password) =>
  axios.post(`${API}/admin/login`, { email, password }).then((r) => r.data);
export const adminMe = () => axios.get(`${API}/admin/me`, { headers: authHeaders() }).then((r) => r.data);

export const adminDashboard = () => axios.get(`${API}/admin/dashboard`, { headers: authHeaders() }).then((r) => r.data);

export const adminListApplications = (filters = {}) => {
  const params = new URLSearchParams(Object.entries(filters).filter(([, v]) => v));
  return axios.get(`${API}/admin/applications?${params}`, { headers: authHeaders() }).then((r) => r.data);
};

export const adminPatchApplication = (num, patch) =>
  axios.patch(`${API}/admin/applications/${num}`, patch, { headers: authHeaders() }).then((r) => r.data);

export const adminAssignCertificate = (num) =>
  axios.post(`${API}/admin/applications/${num}/certificate`, {}, { headers: authHeaders() }).then((r) => r.data);

export const adminPatchPackage = (slug, patch) =>
  axios.patch(`${API}/admin/packages/${slug}`, patch, { headers: authHeaders() }).then((r) => r.data);

export const adminLive = (slug) =>
  axios.get(`${API}/admin/live/${slug}`, { headers: authHeaders() }).then((r) => r.data);

export const adminExportUrl = () => `${API}/admin/applications.csv`;
